import pricing, { PricingModel } from './pricing/pricing'
import transaction, { TransactionModel } from './transaction/index'
import tokens, { TokensModel } from './tokens/index'
import clPools, { CLPoolsModel } from './clpool'

export interface StoreModel {
    pricing: PricingModel
    transaction: TransactionModel
    clPools: CLPoolsModel
    tokens: TokensModel
}

const storeModel: StoreModel = {
    pricing,
    transaction,
    clPools,
    tokens
}

export default storeModel
